import { useTranslation } from 'react-i18next';

import { FailureList } from './UploadInspectionDataModal.style';

const MAX_LISTED_FAILURES = 10;

type ProcessFailure = {
  path?: string | null;
  error: string;
};

type Props = {
  failures: ProcessFailure[];
  skippedCount: number;
  processing: boolean;
};

export const ProcessFailuresDescription = ({ failures, skippedCount, processing }: Props) => {
  const { t } = useTranslation();
  const listed = failures.slice(0, MAX_LISTED_FAILURES);
  const remaining = failures.length - listed.length + skippedCount;

  return (
    <div data-testid="process-failures-description">
      <p>
        {processing
          ? t(
              'inspection.processFailuresStillProcessing',
              'The remaining images are still processing. You will receive a notification when they finish.'
            )
          : t('inspection.processFailuresHint', 'Correct the issues below, then upload again.')}
      </p>
      <FailureList>
        {listed.map(({ path, error }, index) => (
          <li key={index}>
            {/* inspection-service prefixes certain rejections with the image path, want to avoid repeats */}
            {path && !error.includes(path)
              ? t('inspection.processFailureItem', '{{path}}: {{error}}', { path, error })
              : error}
          </li>
        ))}
      </FailureList>
      {remaining > 0 && <p>{t('inspection.processFailuresMore', { count: remaining })}</p>}
    </div>
  );
};
